import React from 'react'
import { PartialCoverdImage } from 'components/PartialCoverdImage'
import { ImageCredits } from 'components/ImageCredits'
import { Quote } from 'components/Quote'
import { PersonIntroduction } from 'components/PersonIntroduction'

export const Farije = ({
  size,
  colors
}: {
  size: { width: number; height: number; isMobile: boolean }
  colors: { main: string; sub: string; cover: string }
}) => (
  <div className='ui vertical segment'>
    <div className='ui text container'>
      <div className='ta text'>
        <PersonIntroduction
          name='Fahrije Baftijari'
          sub={
            <>
              38, Inhaberin einer Siebdruckerei, gelernte Siebdruckerin,
              <br />
              seit 1993 in der Schweiz, Stimmrecht seit 2013
            </>
          }
          img={require('images/farije_quad.jpg')}
          colors={colors}
        />
        <p>
          «Die Sprache war wichtig für mich, um meine Stimme zu finden. Zu
          Beginn war ich gewissermassen die einzige Stimme der Familie. Meine
          Eltern konnten damals kein Deutsch. Ich kam 1993 aus Mazedonien in die
          Schweiz. Mein Vater arbeitete bei einem Landwirt, verdiente wenig und
          hatte kaum frei. Das Geld reichte damals nicht, um meiner Mutter einen
          Deutschkurs zu bezahlen.
        </p>
        <p>
          Ich erinnere mich, wie wir in der Primarschule in Diessenhofen den
          Buchstaben ‹ä› lernten. Wir kriegten Hausaufgaben dazu. Ich wusste
          nicht, wie ich ‹ä› schreiben sollte. Also fragte ich eine andere
          albanische Familie. Es hat mich wahnsinnig verletzt, dass ich das
          nicht selbst konnte.
        </p>
        <p>
          Vor kurzem habe ich in der Schule für albanische Eltern, die aus
          Italien gekommen sind, übersetzt. Die Eltern lebten davor einige Jahre
          in Italien und sprachen noch kein Deutsch. Ich fühlte mich in meine
          Kindheit zurückversetzt. Es kann nicht genug Integrationsangebote
          geben.
        </p>
      </div>
    </div>
    <div className='ui container '>
      <PartialCoverdImage
        url={size.isMobile ? 'farije_hoch.jpg' : 'farije_quer.jpg'}
        covers={
          size.isMobile
            ? ['bottom left', 'top right']
            : ['bottom right', 'top left']
        }
        colors={colors}
        infos={[
          size.isMobile ? 'bottom left' : 'bottom right',
          <ImageCredits
            noSpace
            text='Fahrije Baftijari in ihrer Siebdruckerei in Basadingen, gleich neben ihrem Wohnort Diessenhofen. Trotz Pandemie: Sie bereut den Schritt in die Selbstständigkeit nicht.'
            colors={colors}
          />
        ]}
      />
    </div>{' '}
    <div className='ui text container '>
      <div className='ta text'>
        <p>
          Als ich selbst Mutter wurde, trat ich dem Elternrat bei und gründete
          zusammen mit einer anderen Frau das Café International. Es gibt viele
          Mütter, die aus einem anderen Land kommen und kaum Kontakt zu anderen
          Frauen haben. Die Sprache ist ein Hindernis. Im Café kommen Frauen
          unterschiedlichster Nationalitäten zusammen, um sich auf Deutsch zu
          unterhalten – oder es zu üben. Wir sprechen auch gezielt über Themen
          wie gesunde Ernährung für Kinder, Erziehung und Krebsvorsorge.
        </p>
        <p>
          Seit 2013 darf ich abstimmen und wählen. Seit meiner Einbürgerung habe
          ich nur zwei oder drei Gemeindeversammlungen verpasst. Man erlebt und
          spürt die Themen, die verhandelt werden, ganz anders, als wenn man nur
          in den Medien darüber liest. Für mich fühlte es sich fast am
          wichtigsten an, endlich in meiner Wohngemeinde abstimmen zu können –
          hier lebe ich, das ist meine Heimat.
        </p>

        <p>
          Welches genau meine erste Abstimmung war, daran kann ich mich nicht
          erinnern. Es liegen so viele dazwischen. Aber ich erinnere mich, wie
          aufgeregt ich war. Es war ein spannendes Gefühl, zu realisieren: Jetzt
          zählt auch meine Stimme, ich darf offiziell mitreden und kann das
          Resultat beeinflussen.
        </p>
        <p>
          Wenn ich sehe, dass die Stimmbeteiligung tief ist, finde ich das
          schade. Wenn man abstimmen darf und kann, sollte man das tun. Es geht
          um unsere Zukunft. Speziell Jugendliche sollten mehr dafür
          sensibilisiert werden, wie wichtig politische Beteiligung für ihr
          weiteres Leben ist.
        </p>
        <Quote infos={'Fahrije Baftijari'} colors={colors}>
          «Wenn man abstimmen darf und kann, sollte man das tun. Es geht um
          unsere Zukunft.»
        </Quote>
        <p>
          Aktuell befinde ich mich im Wahlkampf. Politik hat mich schon immer
          interessiert. Mit dem Pass, sagte ich mir: Jetzt will ich selbst
          politisch aktiv werden – aufgrund dessen, was ich erlebt habe. Gerade
          in die Bedürfnisse von Migrantinnen und Müttern kann ich mich gut
          hineinversetzen. Als die SP mich anfragte, ob ich als Stadträtin
          kandidieren möchte, habe ich den Vorschlag mit meinem Mann diskutiert.
          Und den Entschluss gefasst: Ja, das möchte ich! Mein Mann sagte von
          Anfang an, dass er hinter mir stehe. Das sagte er auch, als ich die
          Siebdruckerei, in der ich die Lehre absolvierte, übernahm. Es war ein
          Traum, den ich verwirklichen konnte. Einer, der auch möglich wurde,
          weil mein Mann hilft – im Haushalt und mit den Kindern. Auch meine
          Eltern und meine Brüder unterstützen mich.{' '}
        </p>
        <p>
          Ich wünsche mir, dass Frauen nicht unterdrückt werden, frei
          entscheiden und ihre Meinung aussprechen können – ohne danach etwas
          befürchten zu müssen.»
        </p>
      </div>
    </div>
  </div>
)
